import { useTranslation } from 'react-i18next'

import { TooltipProps } from 'components/Tooltip'
import { Props, Return } from './types'

export const useDataForAdUnitBidderSwitch = ({
  isDisabledByAuth,
  isDisabledByRequiredParams,
  isDisabledByYieldbirdDenied,
  isDisabledByYieldbirdRequested,
  paramsKind,
}: Props): Return => {
  const { t } = useTranslation(['features/globalSetup'], {
    keyPrefix: 'prebid.bidders.edit.bidParamsAndConnection.tooltips',
  })

  const isDisabled: boolean =
    isDisabledByAuth ||
    isDisabledByYieldbirdRequested ||
    isDisabledByYieldbirdDenied ||
    isDisabledByRequiredParams

  let tooltip: TooltipProps | undefined = undefined
  if (isDisabledByYieldbirdDenied) {
    tooltip = { content: t('yieldbirdDenied') }
  } else if (isDisabledByYieldbirdRequested && isDisabledByRequiredParams) {
    tooltip = { content: t('yieldbirdRequested') }
  } else if (isDisabledByYieldbirdRequested) {
    tooltip = { content: t('yieldbirdSetupInProgress') }
  } else if (isDisabledByRequiredParams) {
    tooltip = { content: t('missingParams', { kind: paramsKind.toUpperCase() }) }
  }

  return {
    isDisabled,
    tooltip,
  }
}
